import React, { FunctionComponent } from 'react';

import OfferDetailsBtn from '../OfferDetailsBtn';
import OfferDeleteBtn from '../OfferDeleteBtn';

type Props = {
  fieldValue: Date | string;
  record?: Record<string, any>;
  options?: Record<string, unknown>;
};

const OfferActions: FunctionComponent<Props> = ({
  fieldValue,
  record,
  options,
}) => {
  return (
    <>
      <OfferDetailsBtn
        fieldValue={fieldValue}
        record={record}
        options={options}
      />
      <OfferDeleteBtn
        fieldValue={fieldValue}
        record={record}
        options={options}
      />
    </>
  );
};

export default OfferActions;
